export default ({ request }) => ({
  billStockBorrowMainStatisticsListApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBorrowMain/statistics/list',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
})
